import { render, staticRenderFns } from "./QPagination.vue?vue&type=template&id=b66682e6"
import script from "./QPagination.vue?vue&type=script&lang=js"
export * from "./QPagination.vue?vue&type=script&lang=js"
import style0 from "./QPagination.vue?vue&type=style&index=0&id=b66682e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports